module.exports = __webpack_public_path__ + "img/qin-empire.0a850488.png";